// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const ApproveButton = registerClientReference(
    function() { throw new Error("Attempted to call ApproveButton() from the server but ApproveButton is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/app/admin/billing/_buttons.tsx",
    "ApproveButton",
);
export const RejectButton = registerClientReference(
    function() { throw new Error("Attempted to call RejectButton() from the server but RejectButton is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/app/admin/billing/_buttons.tsx",
    "RejectButton",
);
